import { useEffect, useState } from "react";
import PageHeader from "../../components/pageHeader";
import { API_BASE } from "../../config/apiConfig";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContentLayout from "../../components/mainContentLayout";
import { useToast } from "../../hooks/useToast";
import { FaUserCircle } from "react-icons/fa";
import { formatDate } from "../../utils/date";

export default function SubscriptionDetailPage() {
  const { userId } = useParams();
  const token = sessionStorage.getItem("access_token");
  const navigate = useNavigate();
  const location = useLocation();

  const { showToast, ToastContainer } = useToast();

  // If coming from upgrade page — player & msg are here
  const playerFromState = location.state?.player;
  const [player, setPlayer] = useState(playerFromState);

  // Show toast if redirected from upgrade
  useEffect(() => {
    if (location.state?.msg) {
      showToast(location.state.msg, "success");
    }
  }, [location.state]);

  // Fallback only when refreshing page
  useEffect(() => {
    if (!playerFromState) fetchPlayerFallback();
  }, []);

  const fetchPlayerFallback = async () => {
    try {
      const res = await fetch(
        `${API_BASE}/api/search_players?query=${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      if (data.success && data.results.length > 0) {
        setPlayer(data.results[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (!player) return <p className="p-4">Player not found.</p>;

  return (
    <MainContentLayout>
      <PageHeader title="Player Subscription" backTo="/subscription" />
      <ToastContainer />

      <div className="bg-white shadow rounded-xl p-8 max-w-xl mx-auto w-full">

        <div className="flex justify-center mb-4">
          {player.photo ? (
            <img
              src={player.photo}
              className="w-24 h-24 rounded-full border object-cover"
            />
          ) : (
            <FaUserCircle className="w-24 h-24 text-gray-400" />
          )}
        </div>

        <p className="text-xl font-semibold text-center">{player.fullName}</p>
        <p className="text-sm text-center text-gray-500 mb-4">{player.email}</p>

        <div className="space-y-3 mt-4">
          <InfoRow label="Current Plan" value={player.plan || "Free"} />
          <InfoRow label="Expiry Date" value={formatDate(player.plan_expires_at)} />
          <InfoRow label="Payment Date" value={player.payment_date || "-"} />
        </div>

        <button
          onClick={() =>
            navigate(`/subscription/${userId}/upgrade`, {
              state: { player },
            })
          }
          className="mt-6 w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
        >
          Upgrade Subscription
        </button>
      </div>
    </MainContentLayout>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between border-b pb-2">
      <span className="text-gray-600">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}
